import {Component, OnInit} from '@angular/core';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {Resource} from '../../../user/model/Resource';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {CloneTool} from '../../../global/util/CloneTool';
import {ActivatedRoute, Router} from '@angular/router';
import {SafeUrl} from '@angular/platform-browser';
import {PersonService} from '../../../user/service/person.service';
import {DocumentService} from '../../../user/service/document.service';
import {SignService} from '../../../user/service/sign.service';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {PublicService} from '../../../user/service/public.service';
import {Subject} from 'rxjs';
import {Document} from '../../../user/model/Document';
import {Person} from '../../../user/model/Person';
import {Constant} from '../../../global/util/Constant';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {StamprubrictemporalList} from '../../../user/model/StamprubrictemporalList';
import {StringUtil} from '../../../global/util/StringUtil';
import {DocumentUtil} from '../../../global/util/DocumentUtil';
import {Stampdatetime} from '../../../user/model/Stampdatetime';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {AlertMessage} from '../../../global/util/AlertMessage';
import {IconType} from '../../../global/util/iconType';
import {GeolocationService} from '../../../user/service/geolocation.service';
import {Stamprubrictemporal} from '../../../user/model/Stamprubrictemporal';
import {ConfirmComponent} from '../../../shared/confirm/confirm.component';
import {Response} from '../../../global/util/enum/Response';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-signed-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.css']
})
export class DocumentViewerComponent implements OnInit {
  public signatureForm: any;
  public reloadingPdf = false;
  public resource: Resource;
  public isLastOperator: boolean;
  public personId: number;
  private hashIdentifier: any;
  public resourcesChecked: any[] = [];
  public selectedSignatureDescriptions: any[] = [];
  public signatureDescriptions: any[] = [];
  public eventsSubject: Subject<void> = new Subject<void>();
  public urlStream;
  public signCompleted = false;
  public resourceList: any[] = [];
  public document: Document;
  public person: Person;
  public identityValidation1 = false;
  public rubricSrc: string | ArrayBuffer;
  public hasConfigBalance: boolean;
  public hasMultipleAttachments = false;
  public positionRubrics: any[] = [];
  public loading: boolean;
  public reasonForSigning: string;
  public loadingSign: boolean;
  private geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;
  public alertType: string;
  public messageAlert: any;
  public icon: string;
  public showError: any;
  public confirmRubricPosition: boolean;
  public addedRubric: boolean;
  public filenameSelected: string;

  constructor(private activatedRoute: ActivatedRoute,
              private personService: PersonService,
              private documentService: DocumentService,
              private signService: SignService,
              private route: Router,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private modalService: NgbModal,
              private geolocationService: GeolocationService,
              private publicService: PublicService) {
    this.createForm();
    this.receiveParams();
  }

  ngOnInit(): void {
    if (this.document !== undefined) {
      this.resourceList = this.document._more.resources;
      if (this.isCloudSignature) {
        this.resourceList.push(this.createResourceContract());
      }
      this.resource = this.resourceList[0];
      this.setUrlDoc(this.resource);
      this.hasConfigBalance = this.document._more.hasConfigBalance;
      this.hasMultipleAttachments = this.document._more.resources.length > 1;
      if (LocalStorage.getPositionRubrics()) {
        this.positionRubrics = LocalStorage.getPositionRubrics();
      } else {
        this.createEntities();
      }
      if (TypeSignature.DIGITAL === this.document._more.typeSignature && this.document._more.hasRubricSettings) {
        if (this.document._more.base64RubricFile === null || this.document._more.base64RubricFile === undefined) {
          this.addedRubric = false;
        } else {
          this.addedRubric = true;
        }
        if (this.document._more.dragRubric) {
          this.getListSignatureDescriptionFromDB();
        }
      }
    }
  }

  public createResourceContract(): any {
    const contractResource: Resource = {
      id: 0,
      documentId: this.document.id,
      fileName: 'Contrato de Prestación de Servicios de Certificación.pdf',
      orderResource: this.resourceList.length + 1,
      url: Constant.ROOT_API_V1.concat(
        '/uanataca/public/uanatacarequests/',
        String(this.document._more.uanatacaRequestId),
        '/contract/stream?uuid=',
        this.document._more.uuid
      ),
      url2: null,
      url3: null,
      hashResource: null,
      sign: false,
      length: 0
    };
    return contractResource;
  }

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });
    this.document = history.state.document;
    this.person = history.state.person;
    if (!this.document) {
      this.navigatePrincipalUrl();
    }
  }

  public setUrlDoc(resource: any) {
    this.resource = resource;
    this.getStream();
  }

  public getStream(): void {
    this.reloadingPdf = true;
    const url = this.resource.url;
    this.documentService.download(url).subscribe(value => {
      // @ts-ignore
      const file = new Blob([value], {type: 'application/pdf'});
      this.urlStream = URL.createObjectURL(file);
      this.reloadingPdf = false;
    }, () => {
      this.reloadingPdf = false;
    });
  }

  cutFileName(fileName: string): string {
    const maxLength = 30;
    this.filenameSelected = fileName.length > maxLength ? fileName.substring(0, 10) + ' .... ' + fileName.substring(fileName.length - 15) : fileName;
    return this.filenameSelected;
  }

  rubricDragEnd(resource: any) {
    const resourceWasPushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
    if (!resourceWasPushed && resource.sign) {
      const clonedResource = CloneTool.do(resource);
      this.resourcesChecked.push(clonedResource);
    }
    this.wasChecked(resource);
    this.wasSelected2(resource);
  }

  wasChecked(resource: any) {
    return this.resourcesChecked.find(resource1 => resource1.id === resource.id);
  }

  wasSelected2(resource1: any) {
    return this.resourcesChecked.find(resource => resource1.id === resource.id) !== undefined;
  }

  public getListSignatureDescription(): any {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      return this.selectedSignatureDescriptions;
    } else {
      return this.signatureDescriptions;
    }
  }

  signDocuments() {
    switch (this.document._more.typeSignature) {
      case TypeSignature.ELECTRONIC:
        this.hasConfigRubric ? this.navigateDragDropRubric() : this.signGrafic();
        break;
      case TypeSignature.DIGITAL:
        this.hasConfigRubric ? this.navigateDragDropRubric() : (this.hasMultipleAttachments ? this.signBatchBy() : this.checkStatusOne2One());
        break;
      case TypeSignature.CLOUD:
        this.hasConfigRubric ? this.navigateDragDropRubric() : (LocalStorage.getItem('termConditionAccepted') === 'true' ? this.navigateRequestOtpCode() : this.navigateTermAndConditions());
        break;
      case TypeSignature.REMOTE:
        this.hasConfigRubric ? this.navigateDragDropRubric() : this.navigateCredentialSigning();
        break;
    }

  }

  // TODO correct pass parameters, services shouldn't build urls
  public checkStatusOne2One() {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature();
      }
    }
  }

  public createForm() {
    this.signatureForm = this.formBuilder.group(
      {
        rubricFileId: [''],
        groupRadio: [''],
        page: [''],
        resource: [''],
        anotherPage: [''],
        rubricFileBase64: [''],
        rubricFilename: [''],
        rubricFilename2Show: [''],
        codeOTP: [''],
        documentFrontFileBase64: [''],
        documentFrontFilename: [''],
        documentFrontFilename2Show: [''],
        documentRearFileBase64: [''],
        documentRearFilename: [''],
        documentRearFilename2Show: [''],
        file: [''],
        filename: [''],
        filename2Show: [''],
        rucFile: [''],
        rucFilename: [''],
        rucFilename2Show: [''],
        username: [''],
        password: [''],
        pin: [''],
        uanatacasignaturelevel: [''],
        country: [''],
        reason: [''],
        pagesTotal: [''],
      });
  }

  /*Firma gráfica con codígo de verificación o sin*/
  public signGrafic() {
    this.signGraficDocument();
  }

  public signElectronically() {
    this.showError = false;
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature();
      }
    }
  }

  /**
   * Guarda las posiciones temporales de la rubrica.
   * @private
   */
  private saveStamprubrictemporary(documents?: Document[]) {
    this.loading = true;
    documents = documents !== undefined ? documents : [this.document];
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/stamprubrictemporary');
    const stamprubrictemporalinfo = new StamprubrictemporalList();
    this.getCurrentPositions();
    if (this.reasonForSigning === undefined) {
      this.reasonForSigning = '';
    }
    if (this.digitalSignature) {
      if (LocalStorage.getSelectedSignatureDescriptions()) {
        this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
      } else {
        this.selectedSignatureDescriptions = this.getListSignatureDescription();
      }
      const SelectedSignatureDescription = this.selectedSignatureDescriptions.filter(value => value.initialized === true);
      const docIdentifiers = StringUtil.concatIdentifiers(SelectedSignatureDescription);
      this.positionRubrics.forEach(value => value.signaturedescriptionIds = docIdentifiers);
    }
    stamprubrictemporalinfo.stamprubrictemporals = this.positionRubrics;
    this.signService.save(url, stamprubrictemporalinfo).subscribe(() => {
      this.loading = false;
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature(documents);
      }
    }, () => {
      this.loading = false;
      this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
    });
  }

  /**
   * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
   */
  public verifyUserBalance() {
    this.loading = true;
    const documents: Document[] = [this.document];
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/verify/userbalance?uuid=', this.document._more.uuid);
    this.documentService.verifyUserBalanceOrDemoNotcer(url, documents).subscribe(() => {
      this.sign4TypeSignature(documents);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        this.showError = true;
        this.showMessage(AlertMessage.WARNING, IconType.WARNING, error.error.message);
        return;
      }
      this.signCompleted = false;
      this.showError = true;
      this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
    });
  }

  public sign4TypeSignature(documents?: Document[]) {
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.errorMessageAlert();
      return;
    }
    documents = documents !== undefined ? documents : [this.document];
    switch (this.document._more.typeSignature) {
      case TypeSignature.DIGITAL:
        if (this.hasMultipleAttachments) {
          const identifiers = String(this.document.id);
          this.signService.getUUID(this.personId, identifiers).subscribe((next: any) => {
            const fromUrl = Constant.ROOT_API_V1
              .concat('/public/signs/batch/stream?uuid=')
              .concat(next.uuid);
            const rsignUrl = 'rsign:?batch_csv='.concat(fromUrl);
            window.open(rsignUrl, '_self');

            const checkStatusBatchUrl = Constant.ROOT_API_V1
              .concat('/public/signs/batch/status')
              .concat('?uuid=')
              .concat(next.uuid)
              .concat('&personId=')
              .concat(String(this.personId));
            this.loadingSign = true;
            const interval = setInterval(() => {
              this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
                if (next2.completed === Constant.FINISHED) {
                  this.signCompleted = true;
                  this.getStream();
                  this.saveGeolocation(documents, this.personId, 'Firma digital');
                  clearInterval(interval);
                  this.loadingSign = false;
                  this.loading = false;
                  this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/document-signed/'], {
                    state: {
                      document: this.document,
                      person: this.person
                    }
                  }).then();
                }
              }, () => {
                // Dialog.show(InformType.Danger, this.title);
              });
            }, 3000);
          }, () => {
            this.showError = true;
            this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('MESSAGE.REGISTRATION-ALREADY-EXISTS-IN-THE-SYSTEM'));
          });
        } else {
          this.openRCDSignatureOne2One(this.document);
          const urlOne2One = Constant.ROOT_API_V1.concat('/public/signs/one2one/status')
            .concat('?personId=')
            .concat(String(this.personId))
            .concat('&documentId=')
            .concat(String(this.document.id));
          this.loading = true;
          const interval = setInterval(() => {
            this.documentService.get(urlOne2One).subscribe((next: any) => {
              if (next.completed === Constant.FINISHED) {
                clearInterval(interval);
                this.signCompleted = true;
                this.loading = false;
                this.loadingSign = false;
                this.getStream();
                this.saveGeolocation(documents, this.personId, 'Firma digital');
                this.navigateDocumentSigned();
              }
            }, () => {
              this.showError = true;
              this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
            });
          }, 2000);
        }
        break;
      case TypeSignature.ELECTRONIC:
        this.signElectronic(documents);
        break;
      case TypeSignature.CLOUD:
        this.navigateTermAndConditions();
        break;
      case TypeSignature.REMOTE:
        this.navigateCredentialSigning();
        break;
    }
  }

  addOrRemoveAll(event: any) {
    if (event.target.checked) {
      this.resourceList.forEach(resource => {
        const resourceWasPushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
        if (!resourceWasPushed && resource.sign) {
          const clonedResource = CloneTool.do(resource);
          this.resourcesChecked.push(clonedResource);
        }
      });
    } else {
      this.resourcesChecked = [];
    }
  }

  addRemoveResource(event: any, resource: any) {
    const index = this.resourcesChecked.findIndex(resource1 => resource.id === resource1.id);
    if (event.target.checked) {
      const clonedResource = CloneTool.do(resource);
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      if (!resourcePushed && resource.sign) {
        this.resourcesChecked.push(clonedResource);
      }
    } else {
      this.resourcesChecked.splice(index, 1);
    }
  }

  private errorMessageAlert() {
    this.showError = false;
    let fileName = '';

    function BreakException(message) {
      this.message = message;
      this.name = 'Exception';
    }

    this.resourceList.forEach(resource => {
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      if (!resourcePushed && resource.sign) {
        fileName = resource.fileName;
        this.showError = true;
        this.showMessage(AlertMessage.WARNING, IconType.WARNING, this.translate.instant('MESSAGE.WARNING-CONFIRM-RUBRIC-POSITION').replace('P_DOCUMENT_NAME', '"' + fileName.bold() + '"'));
        this.loading = false;
        throw new BreakException('Detener el recorrido');
      }
    });
  }

  wasAllSelected1() {
    return this.resourcesChecked.length === this.resourceList.length;
  }

  openRCDSignatureOne2One(document: Document): void {
    const rsignUrl = this.getUrlSign(document).toString();
    window.open(rsignUrl, '_self');
  }

  public getUrlSign(document: any): SafeUrl {
    if (this.hasMultipleAttachments) {
      return;
    }
    const urlFrom = DocumentUtil.buildUrlDownload(document, this.personId);
    const urlTo = DocumentUtil.buildUrlUpload(document, this.personId);
    // Si es que tiene configurado el estapando de fecha y hora, se enviará al componente RC para la firma.
    if (document._more.stampdatetime) {
      const stampdatetime: Stampdatetime = document._more.stampdatetime;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(stampdatetime.positionX))
        .concat('&vis_sig_y=')
        .concat(String(stampdatetime.positionY))
        .concat('&vis_sig_width=')
        .concat(String(stampdatetime.widthContainer))
        .concat('&vis_sig_height=')
        .concat(String(stampdatetime.heightContainer))
        .concat('&vis_sig_text=')
        .concat(stampdatetime.description)
        .concat('&vis_sig_page=')
        .concat(String(stampdatetime.stampOn));
    }
      // Si es que tiene configurado el arrastre de rubrica, se enviará al componente RC para la firma y para insertar
    // la imagen en esta misma y agregar datos del certificado.
    else if (this.hasConfigDragRubric) {
      const description = this.getSignatureDescription();
      const stampOn = this.positionRubrics[0].page === 0 ? 1 : this.positionRubrics[0].page;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(this.positionRubrics[0].positionX))
        .concat('&vis_sig_y=')
        .concat(String(this.positionRubrics[0].positionY))
        .concat('&vis_sig_width=')
        .concat(String(this.positionRubrics[0].positionXf))
        .concat('&vis_sig_height=')
        .concat(String(this.positionRubrics[0].positionYf))
        .concat('&vis_sig_text=')
        .concat(description)
        .concat('&vis_sig_page=')
        .concat(String(stampOn))
        .concat('&vis_sig_image=')
        .concat(String(Constant.ROOT_API_V1 + '/public/people/' + this.personId + '/rubrics'));
    }
    return 'rsign:?from='
      .concat(urlFrom)
      .concat('&to=')
      .concat(urlTo);
  }

  private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < documents.length; index++) {
      const date = new Date(Date.now());
      const documentId = documents[index].id;
      this.geolocation = this.setValueGeolocation(documentId, personId);
      this.geolocation.signatureType = signatureType;
      this.geolocation.longTime = Date.now().toString();
      this.geolocation.timeStamp = date.toString();
      this.geolocation.timeZone = this.getGMT(date);
      this.geolocation.identification = null;
      this.geolocationService.save(this.geolocation).subscribe(resp => {

      }, error => {
        this.showMessage(AlertMessage.WARNING, IconType.WARNING, 'El sistema no pudo guardar su ubicación.');
      });
    }
  }

  public signElectronic(documents?: Document[]) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/sign?uuid=', this.document._more.uuid);
    this.documentService.signElectronically(url, documents).subscribe(() => {
      this.loading = false;
      this.signCompleted = true;
      this.saveGeolocation(documents, this.personId, 'Firma gráfica');
      this.isDocumentFinished(this.document.id);
      this.navigateDocumentSigned();
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        this.showError = true;
        this.showMessage(AlertMessage.WARNING, IconType.WARNING, error.error.message);
        return;
      }
      this.signCompleted = false;
      this.showError = true;
      this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
    });
  }

  private isDocumentFinished(documentId: number) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/verify/document/have-manifest-and-traceability/?documentId=').concat(String(documentId));
    if (this.signCompleted) {
      const interval = setInterval(() => {
        this.publicService.get(url).subscribe((next2: any) => {
          if (next2.hasConfManifestAndTraceability) {
            if (next2.documentIsReady) {
              this.loading = false;
              this.reloadPdf();
              clearInterval(interval);
            }
          } else {
            this.loading = false;
            this.getStream();
            clearInterval(interval);
          }
        });
      }, 500);
    }
    setTimeout(() => {
      this.loading = false;
    }, 5000);
  }

  /**
   * Obtiene la descripcciones de firma digital para ser enviadas al componente de firma.
   */
  public getSignatureDescription(): string {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      this.signatureDescriptions = this.selectedSignatureDescriptions;
    }
    let value = '';
    for (const signatureDescription of this.signatureDescriptions) {
      if (signatureDescription.initialized) {
        value += ''
          .concat(signatureDescription.description)
          .concat('%0A');
      }
    }
    value = value.replace('<RUC>', this.person._more.enterpriseDocumentNumber);
    value = value.replace('<ENTERPRISE>', this.person._more.enterpriseName);
    // Se codificara el caracter especial '&' para evitar problemas con el componente de firma
    value = value.replace('&', '%26');
    return StringUtil.removeCharacter(value, 3);
  }

  public signBatchBy() {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature();
      }
    }
  }

  private reloadPdf() {
    this.reloadingPdf = true;
    this.documentService.download(this.resource.url).subscribe(value => {
      const file = new Blob([value], {type: 'application/pdf'});
      this.urlStream = URL.createObjectURL(file);
      this.reloadingPdf = false;
    }, () => {
      this.reloadingPdf = false;
    });
  }

  private setValueGeolocation(documentId: number, personId: number) {
    this.geolocation = new GeolocationIofesign();
    this.geolocation.latitude = String(this.latitude);
    this.geolocation.longitude = String(this.longitude);
    this.geolocation.accuracy = String(this.accuracy);
    this.geolocation.documentId = documentId;
    this.geolocation.personId = personId;
    this.geolocation.ip = LocalStorage.getIpAddress();
    return this.geolocation;
  }

  private createEntities() {
    if (this.document._more.positions) {
      this.positionRubrics = this.resourceList.map(value => {
        const position = this.document._more.positions;
        const positionSplitted = position.split(',', 6);
        const positionRubricInfo: Stamprubrictemporal = {
          resourceId: value.id,
          documentId: value.documentId,
          positionX: Number(positionSplitted[0]),
          positionY: Number(positionSplitted[1]),
          positionXf: Number(positionSplitted[2]),
          positionYf: Number(positionSplitted[3]),
          pageStamp: Number(positionSplitted[4]),
          page: Number(positionSplitted[5]),
          signaturedescriptionIds: null,
        };
        return positionRubricInfo;
      });
      LocalStorage.setItem('positionRubrics', this.positionRubrics);
    }
  }

  public signInCloud(documents: Document[]) {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary(documents);
    } else {
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature(documents);
      }
    }
  }

  public signBox(documents: Document[]) {
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary(documents);
    } else {
      if (this.reasonForSigning === undefined) {
        this.reasonForSigning = '';
      }
      if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sign4TypeSignature(documents);
      }
    }
  }

  /**
   * Obtiene la lista de las descripcciones disponibles para mostrar en la firma digital.
   */
  public getListSignatureDescriptionFromDB() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/signaturedescription?uuid=', this.document._more.uuid)
      .concat('&personId=')
      .concat(String(this.personId));
    this.documentService.post(url).subscribe(value => {
      this.loading = false;
      this.signatureDescriptions = value;
    }, () => {
      this.loading = false;
      this.signCompleted = false;
      this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
    });
  }

  public signGraficDocument() {
    const modalRef = this.modalService.open(ConfirmComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.title = this.translate.instant('TITLE.SIGN-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.PROCEED-WITH-SIGNING-DOCUMENT');
    modalRef.result.then(value => {
      if (Response.Yes === value) {
        this.signElectronically();
      }
    });
  }

  private getGMT(date: Date) {
    return date.toTimeString().split(' ')[1];
  }

  showMessage(alert: string, icon: string, message: any) {
    this.alertType = alert;
    this.messageAlert = message;
    this.icon = icon;
  }

  incompleteResources() {
    const signResources = this.resourceList.filter(resource => resource.sign === true);
    return this.resourcesChecked.length !== signResources.length;
  }

  /**
   * Este método recibe paramatros para navegar entre pantallas.
   * @param hashIdentifier :
   */
  private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
    this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
      state: {
        document: this.document,
        person: this.person
      }
    }).then();
  }


  private navigateDragDropRubric() {
    this.loading = true;
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.errorMessageAlert();
      return;
    }
    this.loading = false;
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'add-or-draw-rubric');
  }

  private navigateTermAndConditions() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'terms-conditions');
  }

  private navigateRequestOtpCode() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'request-otp-code');
  }

  private navigateCredentialSigning() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'signing-credential');
  }

  private navigatePrincipalUrl() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'sign');
  }

  private navigateDocumentSigned() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'document-signed');
  }

  private getCurrentPositions() {
    this.positionRubrics = LocalStorage.getPositionRubrics();
  }

  get typeSignature(): number {
    return this.document._more.typeSignature;
  }

  get isCloseStampingAndIsNotDigitalSignature(): boolean {
    if (this.document !== undefined) {
      return this.document.closedStamping && !this.digitalSignature && !this.isCloudSignature && !this.isRemoteSignature;
    }
  }

  get digitalSignature(): boolean {
    return TypeSignature.DIGITAL === this.document._more.typeSignature;
  }

  get hasConfigDragRubric(): boolean {
    return !this.isCloseStampingAndIsNotDigitalSignature && this.hasConfigRubric && this.hasDragRubric;
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.document._more.typeSignature;
  }

  get isRemoteSignature(): boolean {
    return TypeSignature.REMOTE === this.document._more.typeSignature;
  }

  get showPdf(): boolean {
    return this.document._more.typeSignature === TypeSignature.ELECTRONIC && this.hasIdentityValidation ? this.identityValidation1 : true;
  }

  get hasConfigRubric(): boolean {
    if (this.document !== undefined) {
      return this.document._more.hasRubricSettings;
    }
  }

  get hasIdentityValidation(): boolean {
    return this.document._more.hasIdentityValidation;
  }

  get hasDragRubric(): boolean {
    return this.document._more.dragRubric;
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.placeHoldItRubric;
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_RUBRIC;
  }

  get acceptRubricPlacementChecked() {
    return this.document._more.acceptRubricPlacement;
  }

  get loadMessageHtml() {
    if (this.acceptRubricPlacementChecked) {
      const message = this.translate.instant('MESSAGE.DRAG-AND-DROP-RUBRIC-TO-DOCUMENTS');
      const note = this.translate.instant('TITLE.ATTENTION');
      return `<strong>¡${note}!</strong><div>${message}</div>`;
    }
  }

  get loadAlertMessageHTML() {
    const message = '';
    const note = this.translate.instant('TITLE.ATTENTION');
    return `<strong>¡${note}!</strong><div>${message}</div>`;
  }

  get isElectronicSignature(): boolean {
    return TypeSignature.ELECTRONIC === this.document._more.typeSignature;
  }
}
